import { Pipe, PipeTransform } from '@angular/core';
import { TrailerType } from '@services';

@Pipe({
    name: 'trailerType',
    standalone: true,
})
export class TrailerTypePipe implements PipeTransform {
    transform(value: TrailerType | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case TrailerType.ReeferTandem: return 'Reefer Tandem';
            case TrailerType.ReeferTriAxle: return 'Reefer Tri-Axle';
            case TrailerType.HeaterTandem: return 'Heater Tandem';
            case TrailerType.HeaterTriAxle: return 'Heater Tri-Axle';
            case TrailerType.DryTandem: return 'Dry Tandem';
            case TrailerType.DryTriAxle: return 'Dry Tri-Axle';
            default:
                return value;
        }
    }
}